import {TrinityEvents} from './trinity.js';
import breakpoint from '@core/scripts/helper/breakpoint.js';

// _MUST NOT BE CHANGED_ because otherwise the tracking is broken
const VIDEO_WATCHTIME_TRACKING_INTERVAL = 30 * 1000;

export default function getVideoWithControls({playbackId, withoutOverrideVideo, moduleScope, description} = {}) {
    const contentList = document.getElementsByClassName('content-list');
    const trinityClickPage = {page: contentList[0].getAttribute(`jsh-tracking__trinityClickPage`)};

    const longVideoEntryId = {teaserId: moduleScope.getAttribute('entryId')};

    const videoWithControls = document.createElement('mux-player');
    videoWithControls.setAttribute('disable-cookies', 'true');
    videoWithControls.setAttribute('disable-tracking', 'true');
    videoWithControls.setAttribute('playback-id', playbackId);
    videoWithControls.setAttribute('stream-type', 'on-demand');
    videoWithControls.setAttribute('default-stream-type', 'on-demand');
    if (description) {
        videoWithControls.setAttribute('metadata-video-title', description);
    }

    if (breakpoint.keyIsIn(['large', 'xlarge', 'max'])) {
        const thumbnailImageOverride = moduleScope.getAttribute('thumbnail-image-override');
        if (thumbnailImageOverride) {
            videoWithControls.setAttribute('poster', `${thumbnailImageOverride}?w=${window.innerWidth ?? 1168}`);
        }
    } else {
        const thumbnailImage = moduleScope.getAttribute('thumbnail-image');
        if (thumbnailImage) {
            videoWithControls.setAttribute(
                'poster',
                `${thumbnailImage}?w=${window.innerWidth ?? 768}&h=${window.innerWidth ?? 768}&fit=fill`,
            );
        }
    }
    if (withoutOverrideVideo) {
        videoWithControls.setAttribute('class', `content-platform__long-video__without-override`); //set mobile aspectRatio to 1:1
    }

    let playbackStarted = false;
    let watchTimeTrackingInterval = null;
    let watchTime = 0;
    videoWithControls.addEventListener('play', () => {
        const playEvent = playbackStarted ? 'resume' : 'start';
        const videoClickAttributes = {
            ...longVideoEntryId,
            ...trinityClickPage,
            clickName: playEvent,
        };

        TrinityEvents.sendVideoActionClick(videoClickAttributes);
        playbackStarted = true;

        if (watchTimeTrackingInterval) {
            return;
        }

        watchTimeTrackingInterval = setInterval(() => {
            if (!isElementInViewport(videoWithControls)) {
                return;
            }
            TrinityEvents.sendVideoWatchtime({watchTime: ++watchTime, ...longVideoEntryId, ...trinityClickPage});
        }, VIDEO_WATCHTIME_TRACKING_INTERVAL);
    });

    let endOfVideo = false;
    videoWithControls.addEventListener('pause', () => {
        setTimeout(function () {
            if (!endOfVideo) {
                const videoClickAttributes = {
                    ...longVideoEntryId,
                    ...trinityClickPage,
                    clickName: 'pause',
                };
                TrinityEvents.sendVideoActionClick(videoClickAttributes);
            }
        }, 50); //wait 50ms -->if video ended do not write pause event
        endOfVideo = false;

        clearInterval(watchTimeTrackingInterval);
        watchTimeTrackingInterval = null;
    });

    videoWithControls.addEventListener('ended', () => {
        endOfVideo = true;

        clearInterval(watchTimeTrackingInterval);
        watchTimeTrackingInterval = null;
    });

    return videoWithControls;
}
const isElementInViewport = (domElement) => {
    if (!domElement || !domElement.getBoundingClientRect) {
        return false;
    }
    return (
        domElement.getBoundingClientRect().top < (window.innerHeight || document.documentElement.clientHeight) &&
        domElement.getBoundingClientRect().bottom >= 0
    );
};
